import AtpCard from "./atp";
import CarCard from "./car";
import DriverCard from "./driver";
import OrderHistoryCard from "./orderHistory";

export const CardsConfig = {
  "driver": DriverCard,
  "car": CarCard,
  "atp": AtpCard,
  "orderHistory": OrderHistoryCard,
}